import { jsx as _jsx } from "react/jsx-runtime";
import { useTheme } from '../../theme';
import useReverCardStyles from './ReverCard.Styles';
// Component
export const ReverCard = ({ children, fullWidth = false, className, sx, ...props }) => {
    const theme = useTheme();
    const styles = useReverCardStyles({
        ...{ fullWidth, ...props },
        theme
    });
    return (_jsx("div", { className: `${styles.container} ${className}`, style: sx, ...props, children: children }));
};
export default ReverCard;
